/**
 * Buscar una orden de trabajo y retornarla
 */

import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { OtService } from '../../../../providers/ot.service';
import { ComunicacionService } from '../../../../providers/comunicacion.service';
import { ZerosPipe } from '../../../../pipes/transforms/zeros.pipe';

@Component({
  selector: 'app-buscar-ot',
  templateUrl: './buscar-ot.component.html',
  styleUrls: ['./buscar-ot.component.scss']
})
export class BuscarOtComponent implements OnInit {
  titulo: string = "Buscar orden de trabajo";
  cargando: boolean[] = [];
  ordenes_trabajo: any[] = [];
  form = this._fb.group({
    orden_trabajo_id: [null, Validators.required]
  });

  get orden_trabajo() {
    return this.ordenes_trabajo.find(orden_trabajo => orden_trabajo.id == this.form.get('orden_trabajo_id').value);
  }

  constructor(
    private _dialogRef: MatDialogRef<any>,
    private _fb: FormBuilder,
    private _otSv: OtService,
    private _cmSv: ComunicacionService,
    private _zerosPipe: ZerosPipe,
  ) { }

  ngOnInit() {
    this._prepararForm();
  }

  private _prepararForm() {
    this._traerOrdenesTrabajo();
  }

  private _traerOrdenesTrabajo() {
    this.ordenes_trabajo = [];
    this.cargando.push(true);
    this._otSv.get(
      {
        page: null,
        pageSize: null
      },
      {
        sort: 'fecha_alta',
        order: 'desc'
      },
      {
        generico: '',
        asignables: true // todas las que tengan series disponibles para asignar
      }
    ).subscribe(
      (respuesta) => {
        this.cargando.pop();
        const data = this._cmSv.format(respuesta, false);
        if (data != this._cmSv.SIN_DATA) {
          this.ordenes_trabajo = data.ordenes.map((ot) => {
            const datos_impresion = this._otSv.imprimirOTformato(ot).producto.datos_impresion;
            const id = this._zerosPipe.transform(ot.id, 7);
            let potencia = datos_impresion.filter(x => x.descripcion == "POTENCIA")[0].a_fabricar;
            let tension = datos_impresion.filter(x => x.descripcion == "TENSIÓN")[0].a_fabricar;
            let norma = datos_impresion.filter(x => x.descripcion == "NORMA")[0].a_fabricar;
            let tipo_tension = datos_impresion.filter(x => x.descripcion == "TIPO TENSIÓN")[0].a_fabricar;
            let tipo = datos_impresion.filter(x => x.descripcion == "Tipo")[0].a_fabricar;
            potencia = potencia ? potencia : '';
            tension = tension ? tension : '';
            norma = norma ? norma : '';
            tipo_tension = tipo_tension ? tipo_tension : '';
            // agregamos un campo virtual que sirve para utilizar en el buscador como filtro
            ot['id_caracteristicas'] = id + " | " +
              potencia + " | " +
              tension + " | " +
              norma + " | " +
              tipo_tension + " | " +
              tipo;
            return ot;
          });
        }
      },
      () => {
        this.cargando.pop();
      });
  }

  dismiss() {
    this._dialogRef.close();
  }

  submit() {
    this._dialogRef.close(this.orden_trabajo);
  }
}
